import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.scss';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebaseConfig';
import { logout } from '../services/auth';

const Navbar: React.FC = () => {
  const [user] = useAuthState(auth);
  const [open, setOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    window.location.href = '/login';
  };

  const closeMenu = () => setOpen(false);

  return (
    <>
      {/* Backdrop for mobile menu */}
      <div
        className={`navBackdrop ${open ? 'show' : ''}`}
        onClick={closeMenu}
        aria-hidden={!open}
      />
      <nav className="navbar" role="navigation" aria-label="Main">
        <div className="brand">
          <Link to="/" className="brandLink" onClick={closeMenu}>ReviewBoost AI</Link>
        </div>

        <button
          className={`burger ${open ? 'is-open' : ''}`}
          aria-label="Menu"
          aria-expanded={open}
          aria-controls="nav-links"
          onClick={() => setOpen(v => !v)}
        >
          <span />
          <span />
          <span />
        </button>

        <div id="nav-links" className={`links ${open ? 'open' : ''}`} onClick={closeMenu}>
          <Link to="/" className="link">Accueil</Link>
          <Link to="/directory" className="link">Annuaire</Link>

          <Link to="/dashboard" className="link">Tableau de bord</Link>
          {user ? (
            <button onClick={handleLogout} className="link linkBtn">Déconnexion</button>
          ) : (
            <Link to="/login" className="link">Connexion</Link>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
